import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import env from '@/utils/env'

// 全局检查状态对象
const globalCheckStatus = {
  isWechatBrowser: false,
  isUserLoggedIn: false,
  isInitialCheckComplete: false,
  updateStatus(status) {
    Object.assign(this, status)
    console.log('全局检查状态更新:', status)
  }
}

// 开发环境下打印环境信息
if (process.env.NODE_ENV === 'development') {
  env.logEnvInfo()
}

const app = createApp(App)

// 添加全局属性
app.config.globalProperties.$checkStatus = globalCheckStatus
app.config.globalProperties.$env = env

app.use(router).mount('#app')
